import React, { PropsWithChildren } from "react";

interface Props {}

export default function SectionRow(props: PropsWithChildren<Props>) {
  const { children } = props;

  return <tr className="section-row">{children}</tr>;
}
